import {
    IReferenceLocalitiesCategories,
    IReferenceRegimeTravail,
    IReferenceSectors,
    IReferenceOffersType,
    IReferenceDomaine,
} from '../Models/Reference';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const ReferenceService = {
    async getAllDomains(signal?: AbortSignal): Promise<IReferenceDomaine[]> {
        const response = await fetch('/api/References/GetAllDomain', {
            method: 'GET',
            headers,
            signal,
        });
        return await response.json();
    },
    async getSectors(signal?: AbortSignal): Promise<IReferenceSectors[]> {
        const response = await fetch('/api/References/GetSectorsPanorama ', {
            method: 'GET',
            headers,
            signal,
        });
        return await response.json();
    },
    async getAllOffersType(
        signal?: AbortSignal
    ): Promise<IReferenceOffersType[]> {
        const response = await fetch('/api/References/GetContractsHierarchy', {
            method: 'GET',
            headers,
            signal,
        });
        return await response.json();
    },
    async getAllRegimeTravail(
        signal?: AbortSignal
    ): Promise<IReferenceRegimeTravail[]> {
        const response = await fetch('/api/References/GetRegimesTravail', {
            method: 'GET',
            headers,
            signal,
        });
        return await response.json();
    },
    async getLocalities(
        search: string,
        signal?: AbortSignal
    ): Promise<IReferenceLocalitiesCategories> {
        const response = await fetch(
            '/api/references/searchLocalisation?search=' + search,
            {
                method: 'GET',
                headers,
                signal,
            }
        );
        return await response.json();
    },
};
